export default "__VITE_ASSET__c6fd6bfa__"